module.exports = __webpack_public_path__ + "img/click-to-unlock-toyota-button.f29c4d74.gif";